import { render, staticRenderFns } from "./ConfigPinpad.vue?vue&type=template&id=9bebd4ac&"
import script from "./ConfigPinpad.vue?vue&type=script&lang=js&"
export * from "./ConfigPinpad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports